(ns client-portal.client.reports.list.views
  (:require [client-portal.client.layout :as l]
            [client-portal.client.reports.individual.data]
            [client-portal.client.reports.list.data :as data]
            [client-portal.client.voice-insights.empty-state :as empty-state]
            [shared.core.amelia-light.components.components :as alc]
            [shared.core.reactive :as re]
            [shared.core.style :as style]
            [shared.core.time :as t]))

(defn reports-list []
  (let [reports- (re/subscribe [:reports/list-data-flattened-])
        loading?- (re/subscribe [:reports/list-loading?-])
        has-more?- (re/subscribe [:reports/list-data-has-more?-])
        next-page-loading?- (re/subscribe [:reports/list-next-page-loading?-])
        next-page- (re/subscribe [:reports/list-next-page-])
        creating-edit-session?- (re/subscribe [:reports/creating-edit-session?-])
        mobile?- (re/subscribe [:core/mobile-layout?-])]
    (fn []
      (let [mobile? @mobile?-]
        [alc/table {:no-data-text "No reports to display"
                    :loading-more? @next-page-loading?-
                    :loading? @loading?-
                    :scroll-container-id l/core-scroll-content-id
                    :bottom-px-buffer 200
                    :on-bottom-buffer (when @has-more?-
                                        #(re/dispatch [:reports/load-list [nil {:page @next-page-}]]))
                    :has-more-rows? true
                    :sticky-headers? true
                    :header-top 60
                    :no-data-material-icon :inventory_2
                    :no-data-style empty-state/base-container-style
                    :row-style {:height :auto
                                :align-items :flex-start}
                    :flex-vals (if mobile?
                                 ["1 1 0px" "0 0 96px"]
                                 ["2 1 200px" "3 1 300px" "0 0 220px" "0 0 160px"])
                    :headers (if mobile?
                               ["Title"
                                "Modified"]
                               ["Title"
                                "Description"
                                "Owner"
                                "Last Modified"])
                    :rows (mapv (fn [{:keys [public-id title description source owner-email-address is-owner can-edit last-modified-at]}]
                                  (let [description (when-not (empty? description) description)
                                        modified (some-> last-modified-at
                                                         (t/utc->local)
                                                         (t/as-format (if mobile? "MMM d, y" "MMM d, y h:mm A")))]
                                    {:cells (if mobile?
                                              [{:label [:div {:style {:display :flex
                                                                      :flex-direction :column
                                                                      :gap 2}}
                                                        [:span {:style {:color (style/alc-color "Text/primary")
                                                                        :font-weight 500}}
                                                         title]
                                                        (when description
                                                          [:span {:style {:color (style/alc-color "Text/secondary")}}
                                                           description])]}
                                               {:label modified
                                                :style {:color (style/alc-color "Text/secondary")
                                                        :white-space :nowrap}}]
                                              [{:label title
                                                :style {:color (style/alc-color "Text/primary")
                                                        :font-weight 500}}
                                               {:label description
                                                :style {:color (style/alc-color "Text/secondary")}}
                                               {:label (if is-owner "Me" owner-email-address)
                                                :style {:color (style/alc-color "Text/secondary")}}
                                               {:label modified
                                                :style {:color (style/alc-color "Text/secondary")
                                                        :white-space :nowrap}}])
                                     :actions (when (and can-edit (not= source "ai-summary"))
                                                [{:icon-type :edit
                                                  :disabled? @creating-edit-session?-
                                                  :on-click #(re/dispatch [:reports/edit-report public-id])
                                                  :tooltip-content "Edit Report"}])
                                     :on-click #(re/dispatch [:reports/open-report public-id])}))
                                @reports-)}]))))

(defn root [_]
  (let [reports- (re/subscribe [:reports/list-data-flattened-])
        loading?- (re/subscribe [:reports/list-loading?-])
        report-type- (re/subscribe [:reports/list-report-type-])]
    (re/create-class
      {:component-did-mount
       #(re/dispatch [:reports/initialize])

       :reagent-render
       (fn [args]
         (let [reports @reports-
               loading? @loading?-
               report-type @report-type-]
           [l/logged-in-with-header-nav-vi
            (merge args {:location-dropdown? false
                         :crew-type-radio? false
                         :timeframe-dropdown? false})
            [l/standard-content-container {:title [:div {:style {:display :flex
                                                                 :flex-wrap :wrap
                                                                 :justify-content :space-between
                                                                 :align-items :center
                                                                 :gap 8}}
                                                   [:span {:style {:color :inherit}}
                                                    "Reports"]
                                                   [:div {:style {:width 220}}
                                                    [alc/up-dropdown {:value report-type
                                                                      :options data/report-type-options
                                                                      :on-change #(re/dispatch [:reports/set-list-report-type %])}]]]
                                           :sticky-header? true}
             (cond
               (or loading? (nil? reports)) [empty-state/loading-reports-card]
               (empty? reports) [empty-state/no-data-card
                                 {:text (if (= report-type "ai-summary")
                                          "No AI report summaries to display"
                                          "No reports to display")
                                  :material-icon-type :inventory_2}]
               :else [reports-list])]]))})))
